import styled from 'styled-components';
import media from 'styled-media-query';

import { Link } from 'react-router-dom';
import { QuestionFragment } from '../../gen/graphql';

interface QuestionBodyProgramProps {
  question: QuestionFragment;
}

export const QuestionBodyProgram: React.FC<QuestionBodyProgramProps> = (props) => {
  return (
    <>
      {props.question.program && (
        <Wrapper>
          <Item>
            <ItemLink to={`/programs/${props.question.program.id}/chapters`}>
              教材：{props.question.program.title}
            </ItemLink>
          </Item>

          {props.question.chapter && (
            <Item>
              <ItemLink to={`/programs/${props.question.program.id}/chapters/${props.question.chapter.id}`}>
                章：{props.question.chapter.title}
              </ItemLink>
            </Item>
          )}

          {props.question.practice && (
            <Item>
              <ItemLink to={`/practices/${props.question.practice.id}/body`}>
                課題：{props.question.practice.title}
              </ItemLink>
            </Item>
          )}
        </Wrapper>
      )}
    </>
  );
};

const Wrapper = styled.div`
  margin-top: 0.75rem;
`;

const Item = styled.p`
  margin: 0;
  line-height: 1rem;

  &:nth-of-type(n + 2) {
    margin-top: 0.25rem;
  }

  ${media.lessThan('medium')`
    line-height: .875rem;
  `}
`;

const ItemLink = styled(Link)`
  color: #4183c4;
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.1px;

  &:hover {
    text-decoration: underline;
  }
`;
